import { httpfb, httpwmsapi } from 'src/services';
import queryString from 'query-string';

// Action Types
export const Types = {
  PICKING_BOX_LOADING: 'picking/box/loading',
  PICKING_BOX_SET_DATA: 'picking/box/set/data',
  PICKING_BOX_SET_PAGING: 'picking/box/set/paging',
  PICKING_BOX_SET_FILTER: 'picking/box/set/filter',
  PICKING_BOX_SET_FILTER_CHIP: 'picking/box/set/filter_chip',

  PICKING_BOX_HISTORY_LOADING: 'picking/box/history/loading',
  PICKING_BOX_HISTORY_SET_DATA: 'picking/box/history/set/data',
  PICKING_BOX_HISTORY_SET_PAGING: 'picking/box/history/set/paging',
};

// Reducer
const initialState = {
  loading: false,
  picking_box: [],
  paging: { limit: 25, offset: 0, total: 0 },
  picking_box_history: [],
  picking_box_history_paging: { limit: 25, offset: 0, total: 0 },
  picking_box_filters_chip: [],
  picking_box_filters: [],
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.PICKING_BOX_LOADING:
      return { ...state, loading: action.payload };
    case Types.PICKING_BOX_SET_DATA:
      return { ...state, picking_box: action.payload };
    case Types.PICKING_BOX_SET_PAGING:
      return { ...state, paging: action.payload };
    case Types.PICKING_BOX_SET_FILTER:
      return { ...state, picking_box_filters: action.payload };
    case Types.PICKING_BOX_SET_FILTER_CHIP:
      return { ...state, picking_box_filters_chip: action.payload };

    case Types.PICKING_BOX_HISTORY_LOADING:
      return { ...state, loading: action.payload };
    case Types.PICKING_BOX_HISTORY_SET_DATA:
      return { ...state, picking_box_history: action.payload };
    case Types.PICKING_BOX_HISTORY_SET_PAGING:
      return { ...state, picking_box_history_paging: action.payload };
    default:
      return state;
  }
}

export const Creators = {
  pickingBoxLoading: (value) => ({
    type: Types.PICKING_BOX_LOADING,
    payload: value,
  }),
  pickingBoxSetData: (value) => ({
    type: Types.PICKING_BOX_SET_DATA,
    payload: value,
  }),
  pickingBoxSetPaging: (paging) => ({
    type: Types.PICKING_BOX_SET_PAGING,
    payload: paging,
  }),
  pickingBoxSetFilters: (picking_box_filters) => ({ type: Types.PICKING_BOX_SET_FILTER, payload: picking_box_filters }),
  pickingBoxSetFiltersChip: (picking_box_filters_chip) => ({
    type: Types.PICKING_BOX_SET_FILTER_CHIP,
    payload: picking_box_filters_chip,
  }),
  pickingBoxHistoryLoading: (value) => ({
    type: Types.PICKING_BOX_HISTORY_LOADING,
    payload: value,
  }),
  pickingBoxHistorySetData: (value) => ({
    type: Types.PICKING_BOX_HISTORY_SET_DATA,
    payload: value,
  }),
  pickingBoxHistorySetPaging: (paging) => ({
    type: Types.PICKING_BOX_HISTORY_SET_PAGING,
    payload: paging,
  }),
  getPickingBoxList: (filters = {}) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index', encode: false });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/picking-box?${qry}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  setPickingBox: () => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/picking-box`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  delPickingBox: (id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/picking-box/${id}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getPickingBox: (key) => {
    return new Promise((resolve, reject) => {
      httpfb
        .get(`/logistics/picking-box/key/${key}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
  getPickingBoxPdf: (ids) => {
    return new Promise((resolve, reject) => {
      let _ids = ids.reduce((acc, som, i) => (acc += `${som}${i === ids.length - 1 ? '' : ','}`), '');

      if (ids.length > 1) {
        httpwmsapi
          .get(`/v1/logistica/picking-box/label-pdf/ids/${_ids}`, {
            timeout: 1000 * 30,
          })
          .then(({ data }) => resolve(data))
          .catch((error) => reject(error));
      } else {
        httpwmsapi
          .get(`/v1/logistica/picking-box/label-pdf/${ids[0]}`, {
            timeout: 1000 * 30,
          })
          .then(({ data }) => resolve(data))
          .catch((error) => reject(error));
      }
    });
  },
  getPickingBoxHistory: (filters) => {
    const qry = queryString.stringify(filters, { arrayFormat: 'index' });
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/picking-box/history?${qry}`, { timeout: 1000 * 15 })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
